import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function FeaturedArticles() {
  const featured = articles.filter((a) => a.featured);
  const recent = articles.filter((a) => !a.featured).slice(0, 6);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-800 mb-2">
              精选文章
            </h2>
            <p className="text-sm text-foreground-500">
              编辑推荐的高质量科普内容
            </p>
          </div>
          <Link
            to="/category/sex-education"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featured.map((article) => (
            <ArticleCard key={article.slug} article={article} />
          ))}
        </div>

        {recent.length > 0 && (
          <>
            <div className="mt-10 mb-6">
              <h3 className="font-heading text-xl font-semibold text-foreground-800">
                最新文章
              </h3>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {recent.map((article) => (
                <ArticleCard key={article.slug} article={article} />
              ))}
            </div>
          </>
        )}
      </div>
    </section>
  );
}